/*

翻译文本：
// zh.js
{'MSG':'你好世界'}
// 组件中
<p>{intl.get('MSG')}</p>


翻译html：
// zh.js
{ 'B.HTML':'<b>我是b标签<b>'}
// 组件中
<p>{intl.getHTML('B.HTML')}</p>


翻译数字：
// zh.js
{ 'PRICE.FORMAT':'{price,number,CNY}'}  //price为变量，number为变量类型，CNY为格式。
// 组件中
<p>{intl.get('PRICE.FORMAT',{price:13434355})}</p>


翻译日期：
// zh.js
{ 'DATE.FORMAT':'{date,date,short}'}
// 组件中
<p>{intl.get('DATE.FORMAT',{date:new Date('2015-9-23')})}</p>


*/
const zh_CN = {
  qsTitle: "全部题库",
  appDownLoad: 'APP 下载'
};
export default zh_CN;